"use strict";
/**
 * User-related type definitions
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=user.js.map